import { Lightbulb, X } from "lucide-react";
import { getTopicLabel, getTopicVisual } from "@/lib/topicConfig";
import { TopicItem } from "@/types";
import { cn } from "@/lib/utils";

interface TopicButtonProps {
    selectedTopic: string | null;
    topicList?: TopicItem[];
    onOpen: () => void;
    onClear: () => void;
    className?: string;
}

export default function TopicButton({
    selectedTopic,
    topicList,
    onOpen,
    onClear,
    className,
}: TopicButtonProps) {
    const visual = getTopicVisual(selectedTopic);
    const Icon = visual.icon;
    const label = selectedTopic ? getTopicLabel(selectedTopic, topicList) : "Topic";

    return (
        <div
            onClick={onOpen}
            className={cn(
                selectedTopic ? "topic-button-active" : "topic-button",
                "min-w-0 shrink items-center",
                className,
            )}
            style={selectedTopic ? { borderColor: `${visual.iconColor}33` } : undefined}
        >
            {selectedTopic ? (
                <div
                    className="topic-button-icon"
                    style={{
                        backgroundColor: visual.iconBg,
                        color: visual.iconColor,
                    }}
                >
                    <Icon className="topic-button-icon-svg" aria-hidden />
                </div>
            ) : (
                <Lightbulb
                    className="shrink-0"
                    style={{
                        height: "18px",
                        width: "18px",
                        color: "#1A1A1A",
                        marginRight: "4px",
                    }}
                    aria-hidden
                />
            )}
            <span
                className={cn(
                    "min-w-0 truncate text-left text-sm font-medium",
                    selectedTopic && "topic-button-label",
                )}
                style={selectedTopic ? { color: visual.iconColor } : undefined}
            >
                {label}
            </span>
            {selectedTopic && (
                <button
                    type="button"
                    onClick={(event) => {
                        event.stopPropagation();
                        onClear();
                    }}
                    className="topic-button-clear"
                    aria-label="Clear topic"
                >
                    <X className="h-4 w-4" aria-hidden />
                </button>
            )}
        </div>
    );
}
